import React from 'react';
import PropTypes from 'prop-types';

import './BottomBanner.scss';

import Button from '../../../Input/Button/Button';

export default class BottomBanner extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        /**
         * handler for displaying demo modal
         */
        handleDemoButtonClick: PropTypes.func,
        text: PropTypes.string,
        button: PropTypes.shape({
            onClick: PropTypes.func,
            text: PropTypes.string,
            href: PropTypes.string,
        }),
    };

    static defaultProps = {
        text: 'Connect with the largest career community for women.',
        button: {
            onClick: () => {},
            text: 'Learn more',
            href: '',
        },
    };

    render() {
        return (
            <div className="component-Employer-Marketing-BottomBanner">
                <p className="cta-description">{this.props.text}</p>
                {this.props.button &&
                this.props.button.href &&
                this.props.button.href.length ? (
                    <a href={this.props.button.href}>
                        <Button
                            className="cta-btn"
                            inputStyle="purple-medium-white"
                            value={this.props.button.text}
                        />
                    </a>
                ) : (
                    <Button
                        className="cta-btn"
                        inputStyle="purple-medium-white"
                        value={this.props.button.text}
                        onClick={this.props.button.onClick}
                    />
                )}
            </div>
        );
    }
}
